import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"avatar-bg\"><a href=\"#avatar-bg\"></a> Avatar Background </h1><div class=\"py-5\"> Refer to below example to place avatar as background image: </div><div class=\"py-5\"><div class=\"rounded border p-10 pb-0 d-flex flex-wrap\"><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label\" style=\"background-image:url(&#39;media/avatars/150-7.jpg&#39;);\"></div></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label\" style=\"background-image:url(&#39;media/avatars/150-8.jpg&#39;);\"></div></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label\" style=\"background-image:url(&#39;media/avatars/150-9.jpg&#39;);\"></div></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label\" style=\"background-image:url(&#39;media/avatars/150-10.jpg&#39;);\"></div></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label\" style=\"background-image:url(&#39;media/avatars/150-11.jpg&#39;);\"></div></div><div class=\"symbol symbol-50px me-10 mb-10\"><div class=\"symbol-label\" style=\"background-image:url(&#39;media/avatars/150-12.jpg&#39;);\"></div></div></div></div>", 3)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="symbol symbol-50px">
          <div
            class="symbol-label"
            style="background-image:url('assets/media/avatars/150-7.jpg')"
          ></div>
        </div>
        `), 1)
        ]),
        _: 1
      })
    ])
  ]))
}